import { BaseModel } from 'paliari-js-utils'

const attributes = {
  id: null,
  descricao: '',
  ativo: true,
  permissoes: {},
}

class Perfil extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }
}

export default Perfil
